module.exports = __webpack_public_path__ + "static/media/1-1.c6d3cf60.jpg";